import firebase from 'firebase';

import notificationHelpers from '@/helpers/notificationHelpers';
import axiosHelpers from '@/helpers/axiosHelpers';

export const initializeFirebase = () => {
  if (firebase.apps.length == 0) {
    firebase.initializeApp({
      apiKey: "AIzaSyCxitts66SB_zKTED13egVWX5M94zB2DY4",
      authDomain: "infinitocash.firebaseapp.com",
      databaseURL: "https://infinitocash.firebaseio.com",
      projectId: "infinitocash",
      storageBucket: "infinitocash.appspot.com",
      messagingSenderId: "236464105313",
      appId: "1:236464105313:web:12e257551739a127"
    }
    );
  }
}
var isRegistred = false;
var variable = {};
export const askForPermissioToReceiveNotifications = async (context) => {
  try {
    variable = context;
    if (!isRegistred) {
      isRegistred = true;
      const messaging = firebase.messaging();

      await messaging.requestPermission();
      const token = await messaging.getToken();

      var req = {
        NewDeviceID: token,
        AccountID: context.$store.getters.accountID,
        OldDeviceID: ''
      };

      axiosHelpers.axiosPost('Account/RefreshDeviceID', req, this, function (data) {
      });

      messaging.onMessage((a) => {
        if (variable.getCredit != undefined) {
          variable.getCredit();
        }
        
        if (document.getElementById("btnGenerarNuevoToken") != null && document.getElementById("btnGenerarNuevoToken") != undefined) {
          document.getElementById("btnGenerarNuevoToken").click();
        }

        notificationHelpers.showSuccess(a.notification.title, a.notification.body, variable);
      });

      return token;
    }

  } catch (error) {
    console.error(error);
  }
}